import { AppState } from 'Store'
import { createSelector, Selector } from 'reselect'

const getAll = (state: AppState) => state.interfaceElement.elements.data
const getRequestParams = (state: AppState) => state.interfaceElement.elements.requestParams
const getAllRole = (state: AppState) => state.interfaceElement.roleElements.data
const getRoleRequestParams = (state: AppState) => state.interfaceElement.roleElements.requestParams
const getNavStructure = (state: AppState) => state.interfaceElement.sidebar.structure
const getOpenedSectionIdSelector = (state: AppState) =>
	state.interfaceElement.sidebar.openedSectionId

const getCurrentMenuSection: Selector<AppState, { section_name: string; section_slug: string }> =
	createSelector(
		// @ts-ignore
		[getNavStructure, (state: AppState, location: string) => location],
		(items, location) => {
			let section = items.find((item) => item.url.includes(location))
			if (!section) {
				const currentInterfaceElement = location.split('/')[2]
				section = items.find((item) => item.url.includes(currentInterfaceElement))
			}
			return {
				section_name: section?.name,
				section_slug: section?.slug,
			}
		}
	)
const getEditId = (state) => state.interfaceElement.editId
const getDataItem = (state) => state.interfaceElement.dataItem
const getExpandId = (state) => state.interfaceElement.expandId
const getExpandData = (state) => state.interfaceElement.expandData

export const interfaceElementsSelector = {
	getAll,
	getRequestParams,
	getAllRole,
	getRoleRequestParams,
	getNavStructure,
	getOpenedSectionIdSelector,
	getCurrentMenuSection,
	getEditId,
	getDataItem,
	getExpandId,
	getExpandData,
}
